/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ConditionSVG from '@toucan/client/global/icons/condition.svg';

import { isConditionSparesAndRepairs } from '@toucan/client/global/product';
import { theme } from '@toucan/client/global/theme';

import { FormattedCondition } from '@toucan/client/shared/components/formatted-condition';
import { Link } from '@toucan/client/shared/components/link';
import { useProductConditionDescriptionModal } from '@toucan/client/shared/hooks/use-product-condition-description-modal';

import { ProductDetailsListItem } from '@toucan/client/views/product/components/product-details-list-item/index';

import { ProductConditionListItemProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-condition-list-item';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const StyledConditionButton = styled(Link)`
    ${theme.typography.body_small}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const ProductConditionListItem: FunctionComponent<
    ProductConditionListItemProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    condition,
    conditionDescription,
    ...otherProps
}) => {
    const { t } = useTranslation();
    const { showProductConditionDescriptionModal } =
        useProductConditionDescriptionModal();

    const isSparesAndRepairs = isConditionSparesAndRepairs(condition);

    return (
        <ProductDetailsListItem
            {...otherProps}
            data-testid={dataTestId}
            icon={<ConditionSVG />}
            title={<FormattedCondition condition={condition} />}
        >
            {!isSparesAndRepairs && (
                <StyledConditionButton
                    data-testid={`${dataTestId}__condition-button`}
                    onClick={() =>
                        showProductConditionDescriptionModal(
                            condition,
                            conditionDescription
                        )
                    }
                >
                    {t('Learn about this condition')}
                </StyledConditionButton>
            )}
        </ProductDetailsListItem>
    );
};
